import { GTMPushEvent } from "@/src/helpers/google-tag-manager";

export const generateLabelTextForSearchboxGTMEventE6t = (locations, freeText) => {
  const convertedLocationsToLocationList = [];
  const locationKeys = Object.keys(locations);
  locationKeys.forEach((locationKey) => {
    if (locations[locationKey]) {
      if (locationKey === "city") {
        locations[locationKey].type = locationKey;
        locations[locationKey].id && convertedLocationsToLocationList.push(locations[locationKey]);
      } else if (locationKey !== "key" && locationKey !== "singleTown" && locationKey !== "singleDistrict") {
        locations[locationKey].forEach((location) => {
          location.type = locationKey;
          convertedLocationsToLocationList.push(location);
        });
      }
    }
  });
};

export const formGTMEventGA4 = ({ eventName, eventParameters = {} }) => {
  GTMPushEvent({
    event: "ga4_event",
    event_name: eventName,
    event_parameters: eventParameters,
  });
};

export const formGTMEventWithoutParametersGA4 = ({ eventName }) => {
  GTMPushEvent({
    event: "ga4_event",
    event_name: eventName,
  });
};
